import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedComponentsModule } from 'tabweeb-shared-components';
import { UserManagementLayoutComponent } from './layouts/user-management-layout/user-management-layout.component';
import { ButtonComponent } from './components/button/button.component';
import { TextInputComponent } from './components/text-input/text-input.component';
import { OtpInputComponent } from './components/otp-input/otp-input.component';
import { HomeIconComponent } from './icons/home-icon/home-icon.component';
import { ArrowDownIconComponent } from './icons/arrow-down-icon/arrow-down-icon.component';
import { SaleIconComponent } from './icons/sale-icon/sale-icon.component';
import { PurchaseIconComponent } from './icons/purchase-icon/purchase-icon.component';
import { DollerIconComponent } from './icons/doller-icon/doller-icon.component';
import { SettingsIconComponent } from './icons/settings-icon/settings-icon.component';
import { SearchV2Component } from './components/search-v2/search-v2.component';
import { FilterV2Component } from './components/filter-v2/filter-v2.component';
import { TableRowActionsComponent } from './components/table-row-actions/table-row-actions.component';
import { LoadingBarComponent } from './components/loading-bar/loading-bar.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { ListLayoutComponent } from './layouts/list-layout/list-layout.component';
import { TableV1Component } from './components/table-v1/table-v1.component';
import { TableAccountStatementsComponent } from './components/table-account-statements/table-account-statements.component';
import { TableTaxReturnComponent } from './components/table-tax-return/table-tax-return.component';
import { TextInputRowComponent } from './components/text-input-row/text-input-row.component';
import { SelectInputRowComponent } from './components/select-input-row/select-input-row.component';
import { TabRouterComponent } from './components/tab-router/tab-router.component';
import { RouterModule } from '@angular/router';
import { CollapsedCardComponent } from './components/collapsed-card/collapsed-card.component';
import { NgbCollapseModule, NgbAccordionItem } from '@ng-bootstrap/ng-bootstrap';
import { DatepickerRowComponent } from './components/datepicker-row/datepicker-row.component';
import { DatepickerComponent } from './components/datepicker/datepicker.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { SelectOrAddComponent } from './components/select-or-add/select-or-add.component';
import { CategoriesTreeComponent } from './components/categories-tree/categories-tree.component';
import { MatTreeModule } from '@angular/material/tree';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { ToggleInputComponent } from './components/toggle-input/toggle-input.component';
import { TranslateModule } from '@ngx-translate/core';
import { TranslatorPipe } from './pipe/translator.pipe';
import { UsersIconComponent } from './icons/users-icon/users-icon.component';
import { UploadImageComponent } from './components/upload-image/upload-image.component';
import { UsersIcon1Component } from './icons/users-icon-1/users-icon-1.component';
import { StoreIconComponent } from './icons/store-icon/store-icon.component';
import { PhoneComponentComponent } from './components/phone-component/phone-component.component';
// import { AngularPhoneNumberInput } from 'angular-phone-number-input';
import { DocumentSubTypeTranslatorPipe } from './pipe/documentType.pipe';
import { PaymentTypeTranslatorPipe } from './pipe/paymentType.pipe';
import { ZatcaInvoiceStatePipe } from './pipe/zatca-invoice-state.pipe';
import { ZatcaModePipe } from './pipe/zatca-mode.pipe';
import { ScafoldContainerComponent } from './components/scafold-container/scafold-container.component';
import { HasPermissionDirective } from './directives/has-permission.directive';
import { PaymentMethodPipe } from './pipe/payment-method.pipe';
import { PaymentStatusPipe } from './pipe/payment-status.pipe';
import { BranchHeaderComponent } from './components/branch-header/branch-header.component';
//import { PaymentHistoryModalComponent } from './components/payment-history-modal/payment-history-modal.component';
import { SelectedBranchHeaderComponent } from './components/selected-branch-header/selected-branch-header.component';
import { ThousandSeparatorDirective } from './pipe/thousandSeperation.pipe';
import { EnterAsTabDirective } from './directives/enter-as-tab.directive';
import { DateInputMaskDirective } from './directives/date-input-mask.directive';
import { NumericInputDirective } from './directives/numeric-input.directive';
import { MaterialTimePickerComponent } from '@candidosales/material-time-picker';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { ShiftStatusPipe } from './pipe/shift-status.pipe';
import { ClockComponent } from './icons/clock/clock.component';
import { LanguageToggleButtonComponent } from './components/language-toggle-button/language-toggle-button.component';
import { AngularPhoneNumberInputComponent } from './components/angular-phone-input/angular-phone-number-input.component';
import { ExcelUploaderComponent } from './components/excel-uploader/excel-uploader.component';
import { ExcelUploaderModalComponent } from './components/excel-uploader-modal/excel-uploader-modal.component';
import { NgChartsModule } from 'ng2-charts';
import { NgApexchartsModule } from 'ng-apexcharts';
import { DoughnutChartComponent } from './components/doughnut-chart/doughnut-chart.component';

import { BarChartComponent } from './components/bar-chart/bar-chart.component';
import { AreaChartComponent } from './components/area-chart/area-chart.component';
import { LineChartComponent } from './components/line-chart/line-chart.component';
import { RadioSelectionRowComponent } from './components/radio-selection-row/radio-selection-row.component';
import { SmsIconComponent } from './icons/sms-icon/sms-icon.component';
import { SubscriptionIconComponent } from './icons/subscription-icon/subscription-icon.component';
import { TextareaRowComponent } from './components/textarea-row/textarea-row.component';
import { MessageTypePipe } from './pipe/message-type.pipe';
import { MessageStatusPipe } from './pipe/message-status.pipe';
import { ShiftSummaryDisplayComponent } from './components/shift-summary-display/shift-summary-display.component';
import { RoundingPipe } from './pipe/rounding.pipe';
import { ImportResultsModalComponent } from './components/import-results-modal/import-results-modal.component';
import { ProgressModalComponent } from './components/progress-modal/progress-modal.component';
import { ImportOpeningInventoryPromptModalComponent } from './components/import-opening-inventory-prompt-modal/import-opening-inventory-prompt-modal.component';
import { UtcDatePipe } from './pipes/utc-date.pipe';
import { UtcTimePipe } from './pipes/utc-time.pipe';
import { BranchSelectionModalComponent } from './components/branch-selection-modal/branch-selection-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  NgbDropdownModule,
  NgbModalModule,
  NgbPopoverModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';
import { VersionDetailsModalComponent } from './components/version-details-modal/version-details-modal.component';
import { VersionIconComponent } from './icons/version-icon/version-icon.component';
import { ToolbarV1Component } from './components/toolbar-v1/toolbar-v1.component';
import { VoucherTabsComponent } from './components/voucher-tabs/voucher-tabs.component';
import { LastSegmentPipe } from './pipes/last-segment.pipe';
import { PrintExportDocumentComponent } from './components/print-export-document/print-export-document';
import { NgxBarcode6Module } from 'ngx-barcode6';
import { ReportIconComponent } from './icons/report-icon/report-icon.component';
import { ZakatIconComponent } from './icons/zakat-icon/zakat-icon.component';
import { FinancialYearOnboardingWizardComponent } from './components/financial-year-onboarding-wizard/financial-year-onboarding-wizard.component';
import { AttachFileModalComponent } from './components/attach-file-modal/attach-file-modal.component';
import { InvoiceStatusTranslatorPipe } from './pipe/invoice-status.pipe';
import { FinancialYearStatusPipe } from './pipe/financial-year-status.pipe';
import { FinancialYearPeriodTypePipe } from './pipe/financial-year-period-type.pipe';
import { PaymentHistoryModalComponent } from './components/payment-history-modal/payment-history-modal.component';
import { PrintShiftSummaryComponent } from './components/print-shift-summary/print-shift-summary.component';

@NgModule({
  declarations: [
    UserManagementLayoutComponent,
    ButtonComponent,
    TextInputComponent,
    OtpInputComponent,
    HomeIconComponent,
    ArrowDownIconComponent,
    SaleIconComponent,
    ReportIconComponent,
    ZakatIconComponent,
    PurchaseIconComponent,
    DollerIconComponent,
    SettingsIconComponent,
    SearchV2Component,
    FilterV2Component,
    TableRowActionsComponent,
    LoadingBarComponent,
    PaginationComponent,
    ListLayoutComponent,
    TableV1Component,
    TableAccountStatementsComponent,
    TableTaxReturnComponent,
    TextInputRowComponent,
    SelectInputRowComponent,
    TabRouterComponent,
    CollapsedCardComponent,
    DatepickerRowComponent,
    DatepickerComponent,
    SelectOrAddComponent,
    CategoriesTreeComponent,
    BreadcrumbComponent,
    ToggleInputComponent,
    TranslatorPipe,
    UsersIconComponent,
    UploadImageComponent,
    UsersIcon1Component,
    StoreIconComponent,
    PhoneComponentComponent,
    DocumentSubTypeTranslatorPipe,
    PaymentTypeTranslatorPipe,
    ZatcaInvoiceStatePipe,
    ZatcaModePipe,
    ScafoldContainerComponent,
    HasPermissionDirective,
    PaymentMethodPipe,
    PaymentStatusPipe,
    BranchHeaderComponent,
    SelectedBranchHeaderComponent,
    ThousandSeparatorDirective,
    EnterAsTabDirective,
    DateInputMaskDirective,
    NumericInputDirective,
    ShiftStatusPipe,
    ClockComponent,
    LanguageToggleButtonComponent,
    AngularPhoneNumberInputComponent,
    ExcelUploaderComponent,
    ExcelUploaderModalComponent,
    DoughnutChartComponent,
    BarChartComponent,
    AreaChartComponent,
    LineChartComponent,
    RadioSelectionRowComponent,
    SmsIconComponent,
    SubscriptionIconComponent,
    TextareaRowComponent,
    MessageTypePipe,
    MessageStatusPipe,
    ShiftSummaryDisplayComponent,
    RoundingPipe,
    ImportResultsModalComponent,
    ProgressModalComponent,
    ImportOpeningInventoryPromptModalComponent,
    UtcDatePipe,
    UtcTimePipe,
    BranchSelectionModalComponent,
    VersionDetailsModalComponent,
    VersionIconComponent,
    ImportOpeningInventoryPromptModalComponent,
    ToolbarV1Component,
    VoucherTabsComponent,
    LastSegmentPipe,
    PrintExportDocumentComponent,
    FinancialYearOnboardingWizardComponent,
    AttachFileModalComponent,
    InvoiceStatusTranslatorPipe,
    FinancialYearStatusPipe,
    FinancialYearPeriodTypePipe,
    PaymentHistoryModalComponent,
    PrintShiftSummaryComponent,
  ],
  imports: [
    CommonModule,
    SharedComponentsModule,
    RouterModule,
    NgbCollapseModule,
    NgxDaterangepickerMd.forRoot(),
    MatTreeModule,
    TranslateModule,
    // AngularPhoneNumberInput,
    MaterialTimePickerComponent,
    NgxMaskDirective,
    NgxMaskPipe,
    NgChartsModule,
    NgApexchartsModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModalModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgbPopoverModule,
    NgxBarcode6Module,
    NgbAccordionItem
],
  providers: [
    // CurrencyService
    provideNgxMask(),
    RoundingPipe,
  ],
  exports: [
    SharedComponentsModule,
    UserManagementLayoutComponent,
    ButtonComponent,
    TextInputComponent,
    OtpInputComponent,
    HomeIconComponent,
    ArrowDownIconComponent,
    SaleIconComponent,
    ReportIconComponent,
    ZakatIconComponent,
    PurchaseIconComponent,
    DollerIconComponent,
    SettingsIconComponent,
    SearchV2Component,
    FilterV2Component,
    TableRowActionsComponent,
    LoadingBarComponent,
    PaginationComponent,
    ListLayoutComponent,
    TextInputRowComponent,
    SelectInputRowComponent,
    TabRouterComponent,
    CollapsedCardComponent,
    DatepickerComponent,
    DatepickerRowComponent,
    SelectOrAddComponent,
    TableV1Component,
    TableAccountStatementsComponent,
    TableTaxReturnComponent,
    CategoriesTreeComponent,
    BreadcrumbComponent,
    ToggleInputComponent,
    TranslatorPipe,
    UsersIconComponent,
    UploadImageComponent,
    PhoneComponentComponent,
    DocumentSubTypeTranslatorPipe,
    PaymentTypeTranslatorPipe,
    ZatcaInvoiceStatePipe,
    ZatcaModePipe,
    ScafoldContainerComponent,
    HasPermissionDirective,
    PaymentMethodPipe,
    PaymentStatusPipe,
    BranchHeaderComponent,
    SelectedBranchHeaderComponent,
    ThousandSeparatorDirective,
    EnterAsTabDirective,
    DateInputMaskDirective,
    NumericInputDirective,
    NgxMaskDirective,
    NgxMaskPipe,
    ShiftStatusPipe,
    ClockComponent,
    LanguageToggleButtonComponent,
    ExcelUploaderComponent,
    DoughnutChartComponent,
    BarChartComponent,
    AreaChartComponent,
    LineChartComponent,
    RadioSelectionRowComponent,
    SmsIconComponent,
    SubscriptionIconComponent,
    TextareaRowComponent,
    ToolbarV1Component,
    MessageTypePipe,
    MessageStatusPipe,
    ShiftSummaryDisplayComponent,
    RoundingPipe,
    ImportResultsModalComponent,
    ProgressModalComponent,
    ImportOpeningInventoryPromptModalComponent,
    UtcDatePipe,
    UtcTimePipe,
    BranchSelectionModalComponent,
    VersionDetailsModalComponent,
    VersionIconComponent,
    ImportOpeningInventoryPromptModalComponent,
    VoucherTabsComponent,
    LastSegmentPipe,
    PrintExportDocumentComponent,
    FinancialYearOnboardingWizardComponent,
    AttachFileModalComponent,
    InvoiceStatusTranslatorPipe,
    FinancialYearStatusPipe,
    FinancialYearPeriodTypePipe,
    PaymentHistoryModalComponent,
    NgApexchartsModule,
    NgbPopoverModule,
    NgbTooltipModule,
    PrintShiftSummaryComponent,
  ],
})
export class SharedModule {}
